<template>
  <div class="nxtStepAfterButton">
    <p>
      <IconBase viewBox="0 0 12 12">
        <lock></lock>
      </IconBase>
      <span>Гарантируем безопасность и сохранность ваших данных</span>
    </p>
    <fmCheckBox
      :name="'IS_I_CERTIFY_REGISTRATION'"
      :true-value="'Y'"
      :false-value="'N'"
    ></fmCheckBox>
    <fmCheckBox
      :name="'IS_I_CERTIFY_MARKETING'"
      :true-value="'Y'"
      :false-value="'N'"
    ></fmCheckBox>
<!--    <fmCheckBoxB-->
<!--      :name="'IS_ASSIGNMENT_RIGHT'"-->
<!--      :true-value="true"-->
<!--      :false-value="false"-->
<!--    ></fmCheckBoxB>-->
  </div>
</template>

<script>
  export default {
    name: "nxtStepAfterButton",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      lock: () => import('@/components/svg/interface-essential-188'),
      fmCheckBox: () => import('@/components/form/fmCheckBox'),
      // fmCheckBoxB: () => import('@/components/form/fmCheckBoxB'),
    },
  }
</script>

<style scoped>
  .nxtStepAfterButton {padding: 3vw 0;color: #94B2AA;font-size: 3.1vw;}
  .nxtStepAfterButton p { display: flex;align-items: center;justify-content: center;padding-bottom: 3vw;}
  .nxtStepAfterButton p svg {width: 3vw;height: 3vw;margin-right: 1.5vw;}
  .nxtStepAfterButton p span {}

  /deep/ .visualCheckBox svg {stroke: white}
  /deep/ .visualCheckBox {background: rgba(255, 255, 255, 0.20);}
  @media screen and (min-width: 760px) {
    .nxtStepAfterButton {padding: 1vw 0;font-size: 0.9vw;display: flex;align-items: center;justify-content: flex-end;}
    .nxtStepAfterButton p {padding-bottom: 0}
    .nxtStepAfterButton p svg { width: 1vw;height: 1vw;margin-right: 0.5vw;}
    .nxtStepAfterButton p span {}
    .nxtStepAfterButton .checkBoxWrap {width: 30vw;text-align: left;margin-left: 1vw}

  }

  @media screen and (min-width: 1140px) {
    .nxtStepAfterButton {font-size: 10px;padding: 0;}
    .nxtStepAfterButton p {}
    .nxtStepAfterButton p svg { width: 12px;height: 12px;margin-right: 5px;}
    .nxtStepAfterButton p span {}
    .nxtStepAfterButton .checkBoxWrap {width: 310px;margin-left: 10px;}
  }


</style>
